<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('settings.welcomeModal.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-progress-linear
            v-if="loading"
            :color="enterpriseColor"
            buffer-value="0"
            stream
          />
          <v-layout
            v-if="!loading"
            wrap
            style="padding-top: 0px;"
          >
            <v-flex xs3>
              <div
                class="text-left"
                style="margin-top: 10px"
              >
                {{ $t('settings.welcomeModal.name') }}
              </div>
            </v-flex>
            <v-flex xs9>
              <v-text-field v-model="name" hide-details/>
            </v-flex>
          <v-flex xs3>
              <div
                class="text-left"
                style="margin-top: 10px"
              >
                {{ $t('settings.welcomeModal.image') }}
              </div>
            </v-flex>
            <v-flex xs9>
              <select-image
                v-model="image"
                :isFullWidth="true"
                :enterpriseID="enterpriseID"
                :imageOld='image'
                style="margin-left:0px;margin-top:15px;margin-right: 0px;"
                width="100px"
                :showUploadDirect="true"
              />
              <br />
            </v-flex>
            <v-flex xs3 v-if="isWelcomeModal">
              <div
                class="text-left"
                style="margin-top: 10px"
              >
                {{ $t('settings.welcomeModal.icon') }}
              </div>
            </v-flex>
            <v-flex xs9 v-if="isWelcomeModal">
              <v-btn-toggle
                v-model="welcomeIcon" 
              >
                <v-btn :value="'mdi-information'" @click="welcomeIcon = 'mdi-information'" text>
                  <v-icon>mdi-information</v-icon>
                </v-btn>
                <v-btn :value="'mdi-alert'" @click="welcomeIcon = 'mdi-alert'" text>
                  <v-icon>mdi-alert</v-icon>
                </v-btn>
                <v-btn :value="'mdi-help-circle'" @click="welcomeIcon = 'mdi-help-circle'" text>
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
                <v-btn :value="'mdi-check-circle'" @click="welcomeIcon = 'mdi-check-circle'" text>
                  <v-icon>mdi-check-circle</v-icon>
                </v-btn>
                <v-btn :value="'mdi-email'" @click="welcomeIcon = 'mdi-email'" text>
                  <v-icon>mdi-email</v-icon>
                </v-btn>
                <v-btn :value="'mdi-clock'" @click="welcomeIcon = 'mdi-clock'" text>
                  <v-icon>mdi-clock</v-icon>
                </v-btn>
                <v-btn :value="''" @click="welcomeIcon = ''" text>
                  <v-icon style="opacity: 0.2">mdi-cancel</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex xs12 style="margin: 10px 0 10px 0">
            </v-flex>
            <v-flex xs3 v-if="isWelcomeModal">
              <div
                class="text-left"
                style="margin-top: 10px"
              >
                {{ $t('settings.welcomeModal.message') }}
              </div>
            </v-flex>
            <v-flex xs9 v-if="isWelcomeModal">
              <translate
                type="richText"
                v-model="welcomeMessage"
                :languages="Languages"
                :label="$t('settings.welcomeModal.message')"
                style="padding: 0 10px 0 10px;"
              />
            </v-flex>
            <v-flex xs12 style="margin: 10px 0 10px 0">
            </v-flex>
            <v-flex xs3 v-if="isWelcomeModal">
              <div
                class="text-left"
                style="margin-top: 10px"
              >
                {{ $t('settings.welcomeModal.colors') }}
              </div>
            </v-flex>
            <v-flex xs9 v-if="isWelcomeModal">
              <custom-color-picker-background-and-text
                style="width: 100px;"
                :BGColor="welcomeBGColor"
                :TextColor="welcomeColor"
                :onChangeColor="handleChangeCustomMenuColor"
              />
            </v-flex>
            <v-flex xs3 style="margin-top:20px;">
              <div
                class="text-left"
                style="margin-top: 10px"
              >
                {{ $t('settings.welcomeModal.countDown') }}
              </div>
            </v-flex>
            <v-flex xs9 style="margin-top:20px;">
              <div
                class="text-left"
                style="margin-top: 0px"
              >
                <v-checkbox
                  v-model="isCountDown"
                  :value="isCountDown"
                />
                <v-menu
                  v-if="isCountDown"
                  v-model="modalDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateCountDown"
                      :label="`${$t('settings.welcomeModal.date', locale)}`"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateCountDown"
                    @input="modalDate = false"
                    :locale="locale"  
                  />
                </v-menu>
                <v-layout wrap v-if="isCountDown" >
                  <v-flex xs4>
                    <v-text-field
                      solo
                      v-model="hours"
                      type="number"
                      :min="0"
                      :max="23"
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs1 style="padding-top:15px">
                    <center>
                    :
                    </center>
                  </v-flex>
                  <v-flex xs4>                    
                    <v-text-field
                      solo
                      v-model="minutes"
                      type="number"
                      :min="0"
                      :max="60"
                      hide-details
                    />
                  </v-flex>
                    <v-flex xs3 style="padding-top:15px">
                      (hh:mm)
                    </v-flex>
                </v-layout>
                {{timeCountDown}}
              </div>
            </v-flex>
            <v-flex xs12 style="background-color: #CCC; padding: 0 20px;border-radius: 10px">
              <v-layout wrap>
                <v-flex xs12>
                  <v-checkbox
                    v-model="withButton"
                    :value="withButton"
                    :label="`${$t('settings.welcomeModal.withButton', locale)}`"
                  />
                </v-flex>
                <v-flex xs12 v-if="withButton">
                  <translate
                    type="text"
                    v-model="buttonText"
                    :languages="Languages"
                    :label="$t('settings.welcomeModal.text')"
                    style="padding: 0 10px 0 10px;"
                  />
                </v-flex>
                <v-flex xs12 v-if="withButton" style="padding-bottom: 20px">
                  <translate
                    type="text"
                    v-model="buttonLink"
                    :languages="Languages"
                    :label="$t('settings.welcomeModal.link')"
                    style="padding: 0 10px 0 10px;"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <availability
                v-if="availability"
                :data="availability"
                :onChange="handleChangeAvailability"
                :isWelcomeModal="true"
              />
              <!--v-switch
                v-model="availability.IsTemp"
                :label="$t('menus.isMenuTemp')"
                :color="enterpriseColor"
                hide-details
              />
              <availability
                v-if="availability.IsTemp"
                :editTMP="availability"
              /-->
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="id"
            color="error"
            @click="handleDelete"
          >
            {{$t('common.delete', locale)}}
          </v-btn>
          <v-btn
            @click="handleCancel"
          >
            {{$t('common.cancel', locale)}}
          </v-btn>
          <v-btn
            dark
            :color="enterpriseColor"
            @click="handleSave"
          >
            {{$t('common.save', locale)}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils.js'
  import Translate from '@/components/Translate'
  import SelectImage from '@/components/SelectImage'
  import CustomColorPickerBGAndText from '@/components/CustomColorPickerBGAndText'
  //import Availability from './availability/Index'
  import Availability from '@/components/Availability'
  export default {
    components: {
      SelectImage,
      Translate,
      CustomColorPickerBackgroundAndText: CustomColorPickerBGAndText,
      Availability
    },
    props: {
      showDialog: {
        type: Boolean,
        required: true,
        default: false
      },
      editID: {
        type: String,
        required: false,
        default: null
      },
      onGetData: {
        type: Function,
        required: true
      },
      onClose: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      isWelcomeModal: true,
      id: null,
      name: null,
      image: null,
      welcomeIcon: null,
      welcomeMessage: { es: '12'},
      welcomeBGColor: 'white',
      welcomeColor: 'black',

      isCountDown: false,
      modalDate: false,
      dateCountDown: new Date().toISOString().split('T')[0],
      timeCountDown: null,
      hours: 16,
      minutes: 30,

      availability: null,

      withButton: false,
      buttonText: {
        es: '',
      },
      buttonLink: {
        es: '',
      },

    }),
    computed: {
      ...mapState('app',['Languages', 'enterpriseID', 'BGColor', 'Logo', 'Carousel', 'enterpriseColor', 'Languages', 'DefaultLocale']),
      locale () {
        return this.$store.state.app.locale
      },
    },
    watch: {
      editID (newValue) {
        this.id = newValue
        this.getData(this.id)
      },
      showDialog (newValue) {
        this.dialog = newValue
      }
    },
    mounted () {
      this.id = this.editID
      this.getData(this.id)
      this.dialog = this.showDialog
    },
    methods: {
      getData(id) {
        if (id) {
          this.loading = true
          api.getItem(`enterprises/welcome-modal/${utils.getEnterpiseID()}`, true, id).then(response => {
            this.id = response.ID
            this.name = response.Name
            this.image = response.Image
            this.welcomeIcon = response.Icon
            this.welcomeMessage = response.Message ? JSON.parse(response.Message) : { es: '12'}
            this.welcomeBGColor = response.BGColor
            this.welcomeColor = response.Color
            this.isCountDown = response.IsCountDown && response.CountDown ? true : false
            if (this.isCountDown){
              let aux = response.CountDown.replace('Z','').split('T')
              this.dateCountDown = aux[0]
              aux = aux[1].split(':')
              this.hours = aux[0]
              this.minutes = aux[1]
            }            

            this.availability = response.Availability ? JSON.parse(response.Availability) : {
              isTemp: false
            }
            
            this.withButton = response.WithButton === 1
            if (this.withButton) {
              this.buttonText = JSON.parse(response.ButtonText)
              this.buttonLink = JSON.parse(response.ButtonLink)
            } else {
              this.buttonText = { es: '' }
              this.buttonLink = { es: '' }
            }

            this.loading = false
          })
        } else {
          this.id = null
          this.name = null
          this.image = null
          this.welcomeIcon = null
          this.welcomeMessage = { es: ''}
          this.welcomeBGColor = 'white'
          this.welcomeColor = 'black'

          this.availability = {
            isTemp: false
          }

          this.withButton = false
          this.buttonText = { es: '' }
          this.buttonLink = { es: '' }
        }
        
      },
      handleChangeCustomMenuColor (BGColor, TextColor) {
        this.welcomeBGColor = BGColor
        this.welcomeColor = TextColor
      },
      handleSave () {        
        const body = {
          enterpriseID: utils.getEnterpiseID(),
          name: this.name,
          image: this.image,
          welcomeIcon: this.welcomeIcon,
          welcomeMessage: this.welcomeMessage,
          welcomeBGColor: this.welcomeBGColor,
          welcomeColor: this.welcomeColor,
          availability: this.availability,
          isCountDown: this.isCountDown,
          countDown: this.isCountDown ? `${this.dateCountDown}T${this.hours}:${this.minutes}:00Z` : null
        }

        body.withButton = this.withButton
        body.buttonText = this.buttonText
        body.buttonLink = this.buttonLink

        if (this.id) {
          // edit
          api.updateItem('enterprises/welcome-modal', this.id, body)
          .then(() => {
            this.onGetData()
          })
          .catch(error => {
            console.log('error', error)
          })
        } else {
          // insert
          api.addItem(`enterprises/welcome-modal/${this.id}`, body)
          .then(response => {
            this.onGetData()
          })
          .catch(error => {
            console.log('error', error)
          })
        }
        this.availability = null
        this.dialog = false
      },
      handleCancel () {
        this.dialog = false
        this.availability = null
        this.onClose()
      },
      handleDelete (){
        api.deleteItem('enterprises/welcome-modal', this.id).then(response => {
          if (response.status === 200) {
            this.onGetData()
            this.dialog = false
          }
        })
        this.availability = null
      },
      handleChangeAvailability (v) {
        this.availability =  {
          IsTemp: v.isTemp,
          Per: v.per,
          DateStart: v.dateStart,
          DateEnd: v.dateEnd,
          TimeStart: v.timeStart,
          TimeEnd: v.timeEnd,
          IsAllTimes: v.isAllTimes,
          IsAllDays: v.isAllDays,
          Rec: v.rec,
          DayOfWeek: JSON.stringify(v.dayOfWeek),
          DayOfMonth: JSON.stringify(v.dayOfMonth),
          Alt: v.alt
        }
      }
    }
  }
</script>
